<script setup lang="ts">
import type {NuxtError} from "#app";

const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  error: Object as () => NuxtError,
});

const handleError = () => clearError({ redirect: '/' });

useHead({
  title: props.error?.statusCode + ' - ' + props.error?.statusMessage,
});

const nodeEnv = computed(() => process.env.NODE_ENV || 'unknown');
</script>

<template>
  <div class="min-h-screen flex items-center justify-center bg-square">
    <div class="px-5">
      <h1 class="text-center text-7xl drop-shadow text-red-400 font-extrabold">
        {{ error?.statusCode }}
      </h1>
      <p class="text-center mt-2 text-lg">
        {{ error?.statusMessage }}
      </p>
      <pre v-if="nodeEnv != 'production' && error?.stack" v-html="error?.stack" />
      <div class="text-center">
        <UButton color="error" variant="soft" class="mt-2 cursor-pointer px-6 py-2 rounded-full" @click="handleError">
          Home
        </UButton>
      </div>
    </div>
  </div>
</template>